import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import "./goBack.scss";

import { Icon } from "../icon/Icon";

export const GoBack = ({ url }) => {
  return (
    <Link className="go-back-btn link--with-icon" to={url}>
      <Icon icon={"fa-regular fa-angle-left"} />
      <span>
        <FormattedMessage id={"back_to_selection"} />
      </span>
    </Link>
  );
};

GoBack.propTypes = {
  url: PropTypes.string,
};
